<template>
  <div
    v-for="song in routedDay.songs"
    :key="song.slug"
    class="calendar-sheet__song karaokePlayer-view mt-[1.5vh]"
    :data-tracking-url-song="song.vocalMix.trackingUrl"
  >
    <div
      class="calendar-sheet__song-wrapper bg-school-level rounded-md py-1 shadow-sm text-white items-center flex"
    >
      <div
        class="calendar-sheet__song-label basis-auto grow-0 shrink-0 p-[15px] pr-[7.5px]"
      >
        {{ song.title }}
      </div>
      <div
        class="audioPlayer calendar-sheet__song-player flex items-center h-[51px] min-w-[200px] p-[5px]"
      >
        <song-player
          :song="song.vocalMix"
          v-model:playing="song.playing"
          @update:playing="onUpdatePlaying($event, song)"
          v-model:volume="volume"
          v-model:muted="muted"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import axios from "axios";
import SongPlayer from "../../../media/music/song/SongPlayer.vue";

export default {
  name: "CalendarSheetSongs",
  components: {
    SongPlayer,
  },
  data() {
    return {
      volume: 75,
      muted: false,
    };
  },
  computed: {
    ...mapGetters(["routedDay"]),
  },
  watch: {
    routedDay(newDay, oldDay) {
      // Unset tracking markers and playing state on the old day's songs.
      // eslint-disable-next-line no-unused-expressions
      oldDay.songs?.forEach((song) => {
        // eslint-disable-next-line no-param-reassign
        song.tracked = false;
        // eslint-disable-next-line no-param-reassign
        song.playing = false;
      });
    },
    volume(volume) {
      window.localStorage.setItem("volume", volume);
    },
  },
  mounted() {
    this.applyMemorizedVolume();
  },
  updated() {
    this.applyMemorizedVolume();
  },
  methods: {
    applyMemorizedVolume() {
      this.volume = Number(window.localStorage.getItem("volume") ?? 75);
    },
    onUpdatePlaying(playing, targetSong) {
      if (!playing) {
        // We don't care if anyone stops playing.
        return;
      }

      // Track playback.
      if (!targetSong.tracked && targetSong.vocalMix?.trackingUrl) {
        axios.get(targetSong.vocalMix.trackingUrl, {
          withCredentials: true,
        });
        // eslint-disable-next-line no-param-reassign
        targetSong.tracked = true;
      }

      // However, if someone does *start* playing, then we stop all other players.
      this.routedDay.songs
        .filter((song) => song.slug !== targetSong.slug)
        // eslint-disable-next-line no-return-assign, no-param-reassign
        .forEach((song) => (song.playing = false));
    },
  },
};
</script>

<style lang="css">
.calendar-sheet__song {
  & .bg-player-control-default {
    @apply bg-white;
  }
  & .hover\:bg-player-control-darkened:hover {
    @apply bg-hover;
  }
  & .group:hover .group-hover\:bg-player-control-darkened {
    @apply bg-hover;
  }
  & .text-player-control-default {
    @apply text-white;
  }
}
</style>
